import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuWebsiteAdminComponent } from 'app/components/menus/menu-website-admin/menu-website-admin.component';
import { MenuDefaultComponent } from 'app/components/menus/menu-default/menu-default.component';
import { IonicModule } from '@ionic/angular';
import { AppRoutingModule } from 'app/app-routing.module';
import { AppModule } from 'app/app.module';
import { CountComponent } from '../count/count.component';
import { ReminderBadgeComponent } from '../shared/reminder-badge/reminder-badge.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        AppRoutingModule,
    ],
    declarations: [
        MenuWebsiteAdminComponent,
        MenuDefaultComponent,
        CountComponent,
        ReminderBadgeComponent
    ],
    exports: [
        MenuWebsiteAdminComponent,
        MenuDefaultComponent
    ]
})
export class MenusModule { }
